import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiKey, CreateApiKeyRequest } from "@/types";

export const postApiKey = async (
  token: string,
  apiKeyData: CreateApiKeyRequest,
): Promise<ApiKey> => {
  const response = await fetch(`${API_URL}/api-keys`, {
    method: "POST",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
    body: JSON.stringify(apiKeyData),
  });

  return handleApiResponse(response);
};
